<div class="container-fluid">
  <div class="header-container">
    <div class="row   justify-content-start mb-2">
      <div class="col-12">
      <span class="iso-header ml-2">
{{ "bike.sale_title" | translate }}
</span>
      </div>
    </div>
    <div style="margin-left: auto;">
      <button pButton style="width: 120px;" type="button" class="p-button-raised alternate"
              label="{{ 'bikeshop.service_types.add_new' | translate }}" (click)="addBikeSaleItem()"></button>
    </div>
  </div>
  <div style="display: flex">

    <div style="width: 100%; float: left;">
      <daz-icon class=" icon-shift-12 iso-search-icon-service" [name]="'search'" [size]="'22px'"
                [color]="'#888888'"></daz-icon>
      <input type="text" class="iso-search-bar-service" [(ngModel)]="search" placeholder="{{
              'general.search' | translate
            }}" (keyup)="inputChanged()" (ngModelChange)="search = $event.toUpperCase()"/>
    </div>
    <div>
      <p-progressSpinner *ngIf="loading" [style]="{ width: '30px', height: '30px' }"
                         strokeWidth="2" fill="transparent" animationDuration=".5s"></p-progressSpinner>
    </div>
  </div>
  <div class="content margin-top-16">
    <!--<div class="container-header">
      {{ "bike.sale_title" | translate }}
    </div>-->
    <p-table #saleListTable [columns]="columns" [value]="BikeSaleItemsFiltered" [paginator]="true" [rows]="20">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [ngStyle]="{'width': 'auto'}">
            {{ col.header }}
          </th>
        </tr>
        <!--<tr>
          <th *ngFor="let col of columns" [ngSwitch]="col.field" class="p-fluid">
            <input pInputText type="text" (input)="saleListTable.filter($event.target.value, col.field, col.filterMatchMode)"
                   [value]="saleListTable.filters[col.field]?.value">
          </th>
        </tr>-->
      </ng-template>
      <ng-template pTemplate="body" let-saleItem let-columns="columns">
        <tr [pSelectableRow]="saleItem" (click)="editBikeSalelistItem(saleItem)" style="cursor: pointer">
          <td *ngFor="let col of columns">
            {{ saleItem[col.field] }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-sidebar #NavSideBar [(visible)]="showBikeSaleDetail" position="right"
           [style]="{width:'62em', background: '#F6F6F8', 'overflow-x': 'auto'}"
           (onHide)="closeSaleDetail(); NavSideBar.destroyModal()">
  <div *ngIf="showBikeSaleDetail">
    <app-add-edit-bikesale-item [bikeSaleItem]="BikeSaleItem"
                                (close)="closeSaleDetail()"></app-add-edit-bikesale-item>
  </div>
</p-sidebar>
